import PropTypes from 'prop-types';
import { Badge } from './ui/badge';

const variantMap = {
  normal: 'success',
  serviceable: 'success',
  available: 'success',
  fitted: 'info',
  active: 'success',
  enabled: 'success',
  inactive: 'secondary',
  disabled: 'secondary',
  complete: 'success',
  completed: 'success',
  queued: 'warning',
  running: 'info',
  warning: 'warning',
  worn: 'warning',
  setup_required: 'warning',
  unconfigured: 'warning',
  configured: 'success',
  draft: 'warning',
  due: 'due',
  under_maintenance: 'info',
  empty: 'secondary',
  sent: 'info',
  retread_vendor: 'info',
  overdue: 'destructive',
  damaged: 'destructive',
  failed: 'destructive',
  scrapped: 'secondary',
  lost: 'secondary',
  data_unavailable: 'secondary',
  acknowledged: 'info',
  open: 'warning',
  resolved: 'success',
};

const StateBadge = ({ value, label }) => (
  <Badge variant={variantMap[value] || 'outline'}>
    {label || String(value || 'Unknown').replaceAll('_', ' ')}
  </Badge>
);

StateBadge.propTypes = { value: PropTypes.string, label: PropTypes.string };
export default StateBadge;
